import config from "./config";
import * as plansHelper from "./helpers/plansHelper";

export const PLANS = {
  free: {
    key: "free",
    name: "Free",
    promptPlan: "Pro",
    helper: ({ user, organization }) => plansHelper.isFree({ user, organization }),
  },
  amazonBasic: {
    key: "amazonBasic",
    name: "Amazon Basic",
    promptPlan: "Pro",
    helper: ({ user, organization }) => plansHelper.isAmazonBasic({ user, organization }),
  },
  pro: {
    key: "pro",
    name: "Pro",
    promptPlan: "Pro",
    helper: ({ user, organization }) => plansHelper.isPro({ user, organization }),
  },
  amazonPremium: {
    key: "amazonPremium",
    name: "Amazon Premium",
    promptPlan: "Premium",
    helper: ({ user, organization }) => plansHelper.isAmazonPremium({ user, organization }),
  },
  premium: {
    key: "premium",
    name: "Premium",
    promptPlan: "Premium",
    helper: ({ user, organization }) => plansHelper.isPremium({ user, organization }),
  },
  enterprise: {
    key: "enterprise",
    name: "Enterprise",
    promptPlan: "Enterprise",
    helper: ({ user, organization }) => plansHelper.isEnterprise({ user, organization }),
  },
  appsumo: {
    key: "appsumo",
    name: "AppSumo",
    promptPlan: "Appsumo",
    helper: ({ user, organization }) => plansHelper.isAppsumo({ user, organization }),
  },
  appsumo_3_or_more: {
    key: "appsumo_3_or_more",
    name: "AppSumo",
    promptPlan: "Appsumo",
    helper: ({ user, organization }) => plansHelper.isAppSumo3OrMore({ user, organization }),
  },
  publisher: {
    key: "publisher",
    name: "Publisher",
    promptPlan: "Publisher",
    helper: ({ user, organization }) => plansHelper.isPublisher({ user, organization }),
  },
};

export const PLANS_HIERARCHY = [
  PLANS.publisher,
  PLANS.appsumo_3_or_more,
  PLANS.enterprise,
  PLANS.appsumo,
  PLANS.amazonPremium,
  PLANS.premium,
  PLANS.pro,
  PLANS.amazonBasic,
  PLANS.free,
];

export const ROLES = {
  viewer: {
    key: "viewer",
    name: "Viewer",
  },
  editor: {
    key: "editor",
    name: "Editor",
  },
  admin: {
    key: "admin",
    name: "Admin",
  },
  owner: {
    key: "owner",
    name: "Owner",
  },
};

export const ROLE_HIERARCHY = [
  ROLES.viewer,
  ROLES.editor,
  ROLES.admin,
  ROLES.owner,
];

export const FEATURES = {
  app_sumo_lifetime_plan_banner: {
    plan: PLANS.appsumo,
    role: ROLES.viewer,
  },
  upgrade_button: {
    plan: PLANS.free,
    role: ROLES.viewer,
  },
  create_new_campaign: {
    plan: PLANS.free,
    role: ROLES.admin,
  },
  add_new_campaign_question: {
    plan: PLANS.free,
    role: ROLES.editor,
  },
  video_tags_input: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  video_action_reply: {
    plan: PLANS.amazonBasic,
    role: ROLES.admin,
  },
  video_action_edit: {
    plan: PLANS.enterprise,
    role: ROLES.editor,
  },
  video_share_youtube: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  video_share_amazon: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  video_share_facebook: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  video_share_download: {
    plan: PLANS.pro,
    role: ROLES.editor,
  },
  video_share_link: {
    plan: PLANS.pro,
    role: ROLES.viewer,
  },
  video_expiration: {
    plan: PLANS.free,
    role: ROLES.viewer,
  },
  campaign_custom_privacy_policy: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_custom_terms_and_services: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_collect_user_signature: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_collect_user_info: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_share_qr_code: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_question_action_delete: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_action_duplicate: {
    plan: PLANS.free,
    role: ROLES.admin,
  },
  campaign_expiration: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_max_videos: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  campaign_thank_you_page: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_thank_you_page_link: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_call_to_action: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_custom_branding_company_name: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_custom_branding_company_url: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_custom_branding_company_email: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_custom_video_landing_page: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  campaign_custom_url: {
    plan: PLANS.enterprise,
    role: ROLES.admin,
  },
  organization_management: {
    plan: PLANS.appsumo,
    role: ROLES.owner,
  },
  organization_menu_link: {
    plan: PLANS.appsumo,
    role: ROLES.owner,
  },
  video_hide_watermark: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  plugin_generation: {
    plan: PLANS.amazonBasic,
    role: ROLES.admin,
  },
  plugin_hide_videopeel_logo: {
    plan: PLANS.enterprise,
    role: ROLES.admin,
  },
  plugin_filter: {
    plan: PLANS.amazonBasic,
    role: ROLES.editor,
  },
  plugin_carousel: {
    plan: PLANS.premium,
    role: ROLES.editor,
  },
  plugin_picture_in_picture: {
    plan: PLANS.enterprise,
    role: ROLES.editor,
  },
  editor_features: {
    plan: PLANS.free,
    role: ROLES.editor,
  },
  admin_features: {
    plan: PLANS.free,
    role: ROLES.admin,
  },
};



// WEBPACK FOOTER //
// ./src/plans-permissions.js